module.exports = "/_next/static/images/electricPowerGeneratingConstruction-9138951807a7e3d71ff888573db179ee.webp";